var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareWithTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 15.8,
    height: 15.8,
    rx: 1.9,
    fill: "white",
    stroke: "#A0AEC0",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0322 5.25957L6.73935 10.0775L4.9716 8.17115C4.76363 7.92852 4.38236 7.92852 4.17439 8.13649C3.96642 8.34446 3.93176 8.72574 4.13973 8.93371L6.39273 11.36C6.49672 11.464 6.67003 11.5333 6.80867 11.5333H6.84334C7.01664 11.5333 7.18995 11.4293 7.25928 11.2907L11.0027 5.91814C11.176 5.64085 11.1067 5.29423 10.8641 5.12092C10.5868 4.91295 10.2055 4.98228 10.0322 5.25957Z",
    fill: "#D0004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWithTickWhite);
export default __webpack_public_path__ + "static/media/squareWithTickWhite.80dcea747d25b450be4a4bb79ff82066.svg";
export { ForwardRef as ReactComponent };